module.exports = __webpack_public_path__ + "media/images/icons/outlined/vertical-align-bottom-cb37f156a12baa9cba626b56da8af7e2.svg";